import { createFileRoute } from '@tanstack/react-router';
import { HolidayTable } from '@/components/company/holidays/holiday-table';

export const Route = createFileRoute('/(app)/company/holidays/')({
  component: CompanyHolidaysRoute,
});

function CompanyHolidaysRoute() {
  return (
    <HolidayTable />
  );
}
